import { useEffect, useState } from "react";
import { GoogleFormComponent, GoogleFormStatus, useGoogleForm } from "@components/organisms/GoogleForm";
import { DefaultTemplate } from "@components/templates/default";

export function PQRs() {
    enum Status {
        GoogleForm,
        SaysGoodbye,
    };

    const [status, setStatus] = useState(Status.GoogleForm);
    const { loading, status: formStatus } = useGoogleForm()
    // logger.debug('status', formStatus)

    useEffect(() => {
        if (formStatus == GoogleFormStatus.end) {
            setStatus(Status.SaysGoodbye);
        }
    }, [formStatus]);

    const GoodByeAnouncement = () => <div className="prose p-8">
        ¡Terminado! Estaremos en contacto para atender su solicitud
    </div>;

    return <DefaultTemplate>
        <div className="flex-1 flex items-center justify-center">
            <div className='h-full w-full flex'>
                {{
                    [Status.GoogleForm]: <GoogleFormComponent
                        loading={loading}
                        googleFormID="1FAIpQLScMqucaCye8JNISszBc2cz7xn5o91JI7IzxtW5FCj5IFXopGw"
                        className="w-full h-full"
                        status={formStatus}
                    />,
                    [Status.SaysGoodbye]: <GoodByeAnouncement />,
                }[status]}
            </div>
        </div>
    </DefaultTemplate>;
}
